var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cart-head"},[_c('span',[_vm._v(_vm._s(_vm.$t('retailSale.cart.itemSpecs')))]),_c('span',[_vm._v(_vm._s(_vm.$t('retailSale.cart.qty')))]),_c('span',[_vm._v(_vm._s(_vm.$t('retailSale.cart.price')))]),_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }